<template>
  <el-button :disabled="disabled" :type="type" :plain="plain" :loading="isLoading" :size="size" @click="download">
    {{ describe }}
  </el-button>
</template>

<script>
import axios from 'axios'
import { baseURL } from '@/api/getFile'
import { getCurrentOrganizationId, getToken } from '@/utils/auth'
import { noNeedOrganizationId } from '@/utils/whiteList'

export default {
  props: {
    type: {
      type: String,
      default: 'default',
    },
    describe: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    plain: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => {},
    },
    fileName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    download() {
      this.isLoading = true
      let queryData = { token: getToken(), ...this.params }
      if (!noNeedOrganizationId.includes(baseURL + `${this.url}`)) {
        queryData.organizationId = getCurrentOrganizationId()
      }
      axios({
        url: baseURL + `${this.url}`,
        method: 'POST',
        responseType: 'blob',
        data: queryData,
        headers: { 'Content-Type': 'application/json', Terminal: 3, flowTerminal: 5 },
      }).then(res => {
        this.isLoading = false

        if (res.data.type === 'application/json') {
          const reader = new FileReader()
          reader.readAsText(res.data, 'utf-8')
          reader.onload = () => {
            const { errMsg } = JSON.parse(reader.result)
            this.$message.error(errMsg)
          }
          return
        }
        this.$store.dispatch('tagsView/uprecordDraw', true)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  display: flex;
}
</style>
